import { createContext } from 'react';

export type ColorsContext = {
  foregroundColor?: string;
  backgroundColor?: string;
};

export const ColorsContext = createContext<ColorsContext | null>(null);

export const ColorsContextProvider = ColorsContext.Provider;
